import { ComponentProps, FC } from 'react';

import BaseSvg from '@/designSystem/Icon/Internal/BaseSvg';

export const IconTextNormal: FC<ComponentProps<typeof BaseSvg>> = ({
  className = '',
}) => (
  <BaseSvg className={className}>
    <path d="M3 20V0H10.4784C12.2147 0 13.634 0.283203 14.7363 0.849609C15.8458 1.40951 16.6671 2.16797 17.2003 3.125C17.7334 4.08203 18 5.14974 18 6.32813C18 7.50651 17.7334 8.57747 17.2003 9.54102C16.6744 10.5046 15.8602 11.2728 14.7579 11.8457C13.6556 12.4121 12.2435 12.6953 10.5216 12.6953H5.16138V10.5469H10.4352C11.6239 10.5469 12.5785 10.3613 13.299 9.99023C14.0195 9.61914 14.5418 9.11784 14.866 8.48633C15.1974 7.84831 15.3631 7.12891 15.3631 6.32813C15.3631 5.52734 15.1974 4.8112 14.866 4.17969C14.5418 3.54818 14.0159 3.05339 13.2882 2.69531C12.5605 2.33073 11.5951 2.14844 10.3919 2.14844H5.68012V20H3Z" />
  </BaseSvg>
);
